

import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import VideoPlayer from '../components/VideoPlayer';
import { useEffect, useState } from 'react';

import { Post } from "../services/MainApi";
import VideoPlayerDrm from "../components/VideoPlayerDrm";








const VideoPage = () => {

  
 const location = useLocation();
 const video = location.state;

 const [src, setSrc] = useState('');
 const [srcHls, setSrcHls] = useState('');
 const [DrmToken, setDrmToken] = useState('');

 const [EncryptLevel, setEncryptLevel] = useState('');
   const [clearKeys, setClearKeys] = useState(null);
const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const checkPlatform = () => {
      const platform = navigator.userAgentData?.platform || navigator.platform || '';
      const userAgent = navigator.userAgent;

      // Regular check for iPhone/iPod
      const isAppleMobile = /iPhone|iPad|iPod/.test(userAgent) || /iPhone|iPad|iPod/.test(platform);
      
      // Modern iPad check (which claims to be 'MacIntel' but has touch support)
      const isMaciPad = platform === 'MacIntel' && navigator.maxTouchPoints > 1;

      if (isAppleMobile || isMaciPad) {
        setIsIOS(true);
      }
    };

    checkPlatform();
  }, []);
  
  const fetchVideo = async () => {
    
   

    const res = await Post("",'fetchVideo.php', video );
  
  
     if(res.success){
      setSrc(res.data.url)
      setSrcHls(res.data.urlHls)
      setClearKeys(res.data.clearKeys)
      setDrmToken(res.data.DrmToken)
      setEncryptLevel(res.data.encrypt_level)
//console.log(res.data.DrmToken)
    }   

};
  

useEffect(() => {

fetchVideo();

    }, [video]);



  return (
<> 
 
{
  clearKeys && src && EncryptLevel === 'low'&&
  <VideoPlayer src={src} clearKeys={clearKeys} />
  }
  {
  DrmToken  && EncryptLevel === 'high'&&
  <VideoPlayerDrm src={isIOS ? srcHls : src  } licenseToken={DrmToken} />
  }
</>

    );
};

export default VideoPage;
/*src.replace("/DASH/", "/HLS/") */